export type FormValues = {
	category: string;
	reason: string;
	followupDate: Date | null;
};

export type FormErrors = {
	category?: string;
	reason?: string;
	followupDate?: string;
};

export const INITIAL_VALUES: FormValues = {
	category: "",
	reason: "",
	followupDate: null,
};

// Pure, testable validation — errors are derived from values, never stored.
export const validate = ({
	category,
	reason,
	followupDate,
}: FormValues): FormErrors => ({
	category: category.trim() ? undefined : "Category is required.",
	// A free-text reason is only required when the "Other" category is picked;
	// otherwise the dropdown selection is the reason.
	reason:
		category === "Other" && !reason.trim() ? "Reason is required." : undefined,
	followupDate: followupDate ? undefined : "Follow up date is required.",
});
